var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://cik.cliniqueadmin.com/',
  baseApiUrl: 'https://cik.cliniqueadmin.com/api/'
};
export default Common;